/**
 * GA4 analytics module.
 *
 * Strictly gated by user consent (see /lib/consent.js). No script is loaded,
 * and no page_view events are recorded, unless:
 *   1. REACT_APP_GA4_MEASUREMENT_ID is set in the environment, AND
 *   2. the user has explicitly granted consent.
 *
 * If the env var is empty, every export is a safe no-op.
 */
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";

let initialized = false;

export function isAnalyticsConfigured() {
  return Boolean(GA_ID);
}

export function initAnalytics() {
  if (initialized || !GA_ID) return;
  if (typeof document === "undefined" || typeof window === "undefined") return;

  // gtag.js loader
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  s.setAttribute("data-quantum-analytics", "ga4");
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line func-names
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    anonymize_ip: true,
    send_page_view: false, // we control page_view explicitly via tracker
  });

  initialized = true;
}

export function trackPageView(path, title) {
  if (!initialized || !GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
    page_location: typeof window !== "undefined" ? window.location.href : undefined,
  });
}

export function isAnalyticsInitialized() {
  return initialized;
}
